<template>
    <div class="container-fluid m-2">
        <div class="snackbars">
            <div class="container">
                <div class="row justify-content-center">
                    <snackbar type="success" v-if="showNotification" v-on:close="closeNotification">
                        La décision a été envoyée par email à l'étudiant.
                    </snackbar>
                </div>
            </div>
        </div>
        <div class="row">
            <aside class="col-4 mt-4">
                <div class="section p-0 validations">
                    <div class="tabs">
                        <div class="tab pointer" :class="{ 'is-active' : !coveredMode }" @click="toggleMode">
                            <span>Etudiants à valider </span><span
                            class="badge badge--orange">{{ allStudents ? allStudents.length : 0 }}</span>
                        </div>
                        <div class="tab pointer" :class="{ 'is-active' : coveredMode }" @click="toggleMode">
                            <span>Etudiants incomplet </span><span
                            class="badge badge--orange">{{ coveredStudents ? coveredStudents.length : 0 }}</span>
                        </div>
                    </div>
                    <div v-if="coveredMode">
                        <h3 class="p-3">Etudiants indiqué comme incomplet</h3>
                        <div
                            class="listitem pointer validations"
                            v-for="student in coveredStudents"
                            :key="student.id"
                            v-if="coveredStudents.length > 0"
                            @click="setSelectedStudent(student, true)">
                            <div class="listitem__name">
                                {{ student.user.firstname + " " + student.user.lastname }}
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <h3 class="p-3">Etudiants à valider</h3>
                        <div
                            class="listitem pointer validations"
                            v-for="student in allStudents"
                            :key="student.id"
                            v-if="allStudents.length > 0"
                            @click="setSelectedStudent(student, false)">

                            <div class="listitem__name">
                                {{ student.user.firstname + " " + student.user.lastname }}
                            </div>
                            <div class="listitem__badge">
                                <span v-if="student.subscription.status === 'updated'" class="badge badge--orange">Profil mise à jour</span>
                                <span v-else class="badge badge--green">Nouveau</span>
                            </div>

                        </div>
                    </div>
                </div>
            </aside>
            <div class="col-8">
                <div v-if="selectedStudent">
                    <div class="actionsBar actionBar--normalMargin  mt-3 mb-3">
                        <div class="ml-auto">
                            <button @click="previous" type="button" class="btn-dark-grey" :disabled='!hasPrevious'>
                                Précédent
                            </button>
                            <button type="button" class="btn-dark-grey" @click="postValidate" v-if="!coveredMode">
                                Valider
                            </button>
                            <button type="button" class="btn-dark-grey" @click="postIncomplete"
                                    v-if="!coveredMode">
                                A completer
                            </button>
                            <button type="button" class="btn-dark-grey" @click="postDecline">
                                Refuser
                            </button>
                            <button @click="next" type="button" class="btn-dark-grey" :disabled='!hasNext'>
                                Suivant
                            </button>
                        </div>
                    </div>
                    <div class="section mt-4">
                        <div class="row">
                            <div class="col-12">
                                <div class="section__infos mb-3">
                                    <svg viewBox="0 0 24 24">
                                        <use xlink:href="#information"></use>
                                    </svg>
                                    La décision (à compléter ou validé) est envoyée automatiquement par email à l'étudiant
                                </div>
                            </div>
                        </div>
                        <div class="row">

                            <div class="col-3">
                                <div class="profileOverview__pic avatar avatar--large avatar--rounded">
                                    <img v-if="selectedStudent.picture_url"
                                         :src="selectedStudent.picture_url"
                                         alt="" class="avatar__default">
                                </div>

                                <div class="profileOverview__infos">
                                    <h2 class="profileOverview__name">
                                        {{ selectedStudent.user.firstname + " " + selectedStudent.user.lastname }}</h2>
                                    <p>
                                        {{ selectedStudent.birth_date ? format(selectedStudent.birth_date) : '' }}
                                    </p>
                                    <p v-if="selectedStudent.study_level">
                                        {{ selectedStudent.study_level.name }}
                                    </p>
                                    <p>
                                        {{ selectedStudent.study_section.name }}
                                    </p>
                                </div>

                                <div>
                                    <p v-if="epflProfileLoading">
                                        <span class="badge badge--grey">Chargement...</span>
                                    </p>
                                    <div v-else-if="epflProfile.exist">
                                        <span class="badge badge--green">Profil existant</span>
                                        <p class="font-small">
                                            Informations provenant de la page <a :href="epflProfile.url" target="_blank" class="pb-1 d-block">{{ epflProfile.url }}</a>
                                            {{ epflProfile.section }}
                                        </p>
                                    </div>
                                    <p v-else>
                                        <span class="badge badge--orange">Profil inexistant</span>
                                    </p>
                                </div>

                                <div class="mt-5">
                                    <a :href="selectedStudent.view_url" class="btn-dark-grey" target="_blank">
                                        Voir profil
                                    </a>
                                </div>

                            </div>
                            <div class="col-9">
                                <div v-if="selectedStudent.cv_url">
                                    <iframe :src="selectedStudent.cv_url" width="100%" height="500px"></iframe>
                                </div>
                                <div v-else>
                                    <h2>Aucun CV</h2>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="actionsBar actionBar--normalMargin  mt-3 mb-3">
                        <div class="ml-auto">
                            <button type="button" class="btn-dark-grey" disabled>
                                Précédent
                            </button>
                            <button type="button" class="btn-dark-grey" disabled>
                                Suivant
                            </button>
                        </div>
                    </div>
                    <div class="section mt-4">
                        <p>Aucun étudiant a valider</p>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>

import moment from "moment";
import Snackbar from "../AppNotifications/Snackbar";

export default {
    components: {
        Snackbar
    },
    props: {
        students: Array,
        unCompleteStudents: Array,
        routeIncomplete: String,
        routeValidate: String,
        routeDecline: String,
        labels: Array,
        unCompleteStatus: String
    },
    data: function () {
        return {
            selectedStudent: null,
            allStudents: this.students,
            coveredStudents: this.unCompleteStudents,
            index: 0,
            indexCovered: 0,
            coveredMode: false,
            showNotification: false,
            abortController: null,
            epflProfileLoading: true,
            epflProfile: {
                exist: null,
                section: null,
                url: null
            },
        }
    },
    methods: {
        closeNotification(event) {
            this.showNotification = !event
        },
        format(birthDay) {
            return moment(birthDay).format('L')
        },
        toggleMode() {
            this.coveredMode = !this.coveredMode
            if (this.coveredMode) {
                this.selectedStudent = this.coveredStudents[this.indexCovered]
            } else {
                this.selectedStudent = this.allStudents[this.index]
            }
        },
        postIncomplete() {
            if (this.routeIncomplete) {
                axios.post(this.routeIncomplete, {
                        'item': this.selectedStudent.subscription.id
                    }
                ).then((response) => {
                    this.coveredStudents.push(this.selectedStudent)
                    this.allStudents.splice(this.index, 1)
                    if (this.allStudents.length > 0) {
                        if (this.index === this.allStudents.length) {
                            this.index--
                        }
                        this.selectedStudent = this.allStudents[this.index]
                    } else {
                        this.selectedStudent = null
                        this.index = 0
                    }
                    this.showNotification = true
                }).catch(function (error) {
                    // error management?
                    console.log(error);
                });
            }
        },
        postValidate() {
            if (this.routeValidate) {
                axios.post(this.routeValidate, {
                        'item': this.selectedStudent.subscription.id
                    }
                ).then((response) => {
                    this.allStudents.splice(this.index, 1)
                    if (this.allStudents.length > 0) {
                        if (this.index === this.allStudents.length) {
                            this.index--
                        }
                        this.selectedStudent = this.allStudents[this.index]
                    } else {
                        this.selectedStudent = null
                        this.index = 0
                    }
                }).catch(function (error) {
                    // error management?
                    console.log(error);
                });
            }

        },
        postDecline() {
            if (this.routeDecline) {
                axios.post(this.routeDecline, {
                        'item': this.selectedStudent.subscription.id
                    }
                ).then((response) => {
                    this.allStudents.splice(this.index, 1)
                    if (this.allStudents.length > 0) {
                        if (this.index === this.allStudents.length) {
                            this.index--
                        }
                        this.selectedStudent = this.allStudents[this.index]
                    } else {
                        this.selectedStudent = null
                        this.index = 0
                    }
                }).catch(function (error) {
                    // error management?
                    console.log(error);
                });
            }
        },
        previous() {
            if (this.coveredMode) {
                if (this.coveredStudents.length > 0) {
                    if (this.indexCovered > 0) {
                        this.indexCovered--
                        this.selectedStudent = this.coveredStudents[this.indexCovered]
                    }
                } else {
                    this.indexCovered = 0;
                    this.selectedStudent = null
                }
            } else {
                if (this.allStudents.length > 0) {
                    if (this.index > 0) {
                        this.index--
                        this.selectedStudent = this.allStudents[this.index]
                    }
                } else {
                    this.indexCovered = 0;
                    this.selectedStudent = null
                }
            }
        },

        next() {
            if (this.coveredMode) {
                if (this.coveredStudents.length > 0) {
                    if (this.indexCovered < this.coveredStudents.length - 1) {
                        this.indexCovered++
                        this.selectedStudent = this.coveredStudents[this.indexCovered]
                    }
                } else {
                    this.indexCovered = 0;
                    this.selectedStudent = null
                }
            } else {
                if (this.allStudents.length > 0) {
                    if (this.index < this.allStudents.length - 1) {
                        this.index++
                        this.selectedStudent = this.allStudents[this.index]
                    }
                } else {
                    this.index = 0;
                    this.selectedStudent = null
                }
            }

        },
        setSelectedStudent(toDisplayStudent, mode) {
            this.coveredMode = mode
            if (this.coveredMode) {
                let newIndex = this.coveredStudents.findIndex(student => student.id === toDisplayStudent.id)
                if (newIndex > -1) {
                    this.indexCovered = newIndex
                    this.selectedStudent = this.coveredStudents[newIndex]
                }
            } else {
                let newIndex = this.allStudents.findIndex(student => student.id === toDisplayStudent.id)
                if (newIndex > -1) {
                    this.index = newIndex
                    this.selectedStudent = this.allStudents[newIndex]
                }
            }
        }
    },
    beforeMount() {
        if (this.allStudents.length > 0) {
            this.selectedStudent = this.allStudents[this.index]
        }
    },
    mounted() {

    },
    computed: {
        hasPrevious() {
            if (this.coveredMode) {
                if (this.coveredStudents.length > 0 && this.indexCovered > 0) {
                    return true
                }
            } else {
                if (this.allStudents.length > 0 && this.index > 0) {
                    return true
                }
            }
            return false
        },
        hasNext() {
            if (this.coveredMode) {
                if (this.coveredStudents.length > 0 && this.indexCovered < this.coveredStudents.length - 1) {
                    return true
                }
            } else {
                if (this.allStudents.length > 0 && this.index < this.allStudents.length - 1) {
                    return true
                }
            }
            return false
        }
    },
    watch: {
        selectedStudent: function (newVal, oldVal) {
            if (this.abortController) {
                this.abortController.abort();
            }

            this.abortController = new AbortController();
            this.epflProfileLoading = true;
            this.epflProfile.exist = null;
            this.epflProfile.section = null;

            axios.post('/admin/students/check-exist', {
                firstname: newVal.user.firstname,
                lastname: newVal.user.lastname,
            }, {
                signal: this.abortController.signal
            }).then((response) => {
                console.log(response.request)
                this.epflProfile.exist = response.data.exists;
                this.epflProfile.section = response.data.section;
                this.epflProfile.url = response.data.url;

                this.epflProfileLoading = false;
            }).catch((error) => {
                if (!axios.isCancel(error)) {
                    console.log(error);
                }
            });
        }
    }
};
</script>
